import { render } from "./icon-x.svg?vue&type=template&id=5154ce14"
const script = {}
script.render = render

export default script